"use client";

import { c as _c } from "react/compiler-runtime";
import FileIcon from "~/components/icons/file-icon-eon";
import InterviewIcon from "~/components/icons/interview-icon-eon";
import PcMacIcon from "~/components/icons/pc-mac-icon-eon";
import SectionIntro from "~/components/job-page/application-process/application-process-intro-eon";
import ApplicationProcessSlider from "~/components/job-page/application-process/application-process-slider-eon";
import { useLanguage } from "~/translations/loader/use-language";
import type { JobadComponentProps } from "~/types/job";

/**
 * Application process with first step “apply by e-mail” (jobposting_process_*).
 * Shared by Control Solutions and EDG-Sub job pages.
 */
export default function ApplicationProcessMailFirstEon(_props) {
  const $ = _c(32);
  const t = useLanguage();
  let t0;
  let t1;
  let t2;
  let t3;
  if ($[0] !== _props.job.data.applicationUrl || $[1] !== _props.job.data.company || $[2] !== t.jobad_process_step01_title || $[3] !== t.jobad_process_step02_text || $[4] !== t.jobad_process_step02_title || $[5] !== t.jobposting_process_step01_text || $[6] !== t.jobposting_process_step01_text_online || $[7] !== t.jobposting_process_step01_title) {
    const companyName = _props.job.data.company.split(" GmbH")[0].split(" Limited")[0];
    const hasApplyByEmail = _props.job.data.applicationUrl.startsWith("mailto:");
    const t4 = hasApplyByEmail ? t.jobposting_process_step01_title : t.jobad_process_step01_title;
    const t5 = hasApplyByEmail ? t.jobposting_process_step01_text : t.jobposting_process_step01_text_online;
    let t6;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <PcMacIcon className="size-16" />;
      $[12] = t6;
    } else {
      t6 = $[12];
    }
    if ($[13] !== t4 || $[14] !== t5) {
      t3 = {
        id: 1,
        title: t4,
        text: t5,
        iconHighlight: t6
      };
      $[13] = t4;
      $[14] = t5;
      $[15] = t3;
    } else {
      t3 = $[15];
    }
    t0 = 2;
    t1 = t.jobad_process_step02_title;
    t2 = t.jobad_process_step02_text.replace("E.ON", companyName);
    $[0] = _props.job.data.applicationUrl;
    $[1] = _props.job.data.company;
    $[2] = t.jobad_process_step01_title;
    $[3] = t.jobad_process_step02_text;
    $[4] = t.jobad_process_step02_title;
    $[5] = t.jobposting_process_step01_text;
    $[6] = t.jobposting_process_step01_text_online;
    $[7] = t.jobposting_process_step01_title;
    $[8] = t0;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t0 = $[8];
    t1 = $[9];
    t2 = $[10];
    t3 = $[11];
  }
  let t4;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <InterviewIcon className="size-16" />;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  let t5;
  if ($[17] !== t0 || $[18] !== t1 || $[19] !== t2) {
    t5 = {
      id: t0,
      title: t1,
      text: t2,
      iconHighlight: t4
    };
    $[17] = t0;
    $[18] = t1;
    $[19] = t2;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  let t6;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <FileIcon className="size-16" />;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  let t7;
  if ($[22] !== t.jobad_process_step03_text || $[23] !== t.jobad_process_step03_title) {
    t7 = {
      id: 3,
      title: t.jobad_process_step03_title,
      text: t.jobad_process_step03_text,
      iconHighlight: t6
    };
    $[22] = t.jobad_process_step03_text;
    $[23] = t.jobad_process_step03_title;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  let t8;
  if ($[25] !== t3 || $[26] !== t5 || $[27] !== t7) {
    t8 = [t3, t5, t7];
    $[25] = t3;
    $[26] = t5;
    $[27] = t7;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  const steps = t8;
  let t9;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <SectionIntro />;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  let t10;
  if ($[30] !== steps) {
    t10 = <section className="outer-container py-container" id="applicationProcess"><div className="inner-container">{t9}<ApplicationProcessSlider steps={steps} /></div></section>;
    $[30] = steps;
    $[31] = t10;
  } else {
    t10 = $[31];
  }
  return t10;
}